export const SIDEBAR = {
	container: 'sidebar-container',
	brand: 'sidebar-brand',
	link: 'sidebar-link',
};

export const TOPBAR = {
	container: 'topbar-container',
	userName: 'topbar-user-name',
	userMenu: 'topbar-user-menu',
};

export const DASHBOARD = {
	memberRoot: 'member-dashboard-root',
	adminRoot: 'admin-dashboard-root',
	welcomeCard: 'dashboard-welcome-card',
	vipCard: 'dashboard-vip-card',
	modulesCard: 'dashboard-modules-card',
	pendingVipCard: 'dashboard-pending-vip-card',
	requestIndikatorCard: 'dashboard-request-indikator-card',
	usersCard: 'dashboard-users-card',
};
